import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=b7432342&scoped=true&lang=pug"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "../../static/loginPage/plugins.css?vue&type=style&index=0&id=b7432342&prod&scoped=true&lang=css&external"
import style1 from "../../static/loginPage/common.css?vue&type=style&index=1&id=b7432342&prod&scoped=true&lang=css&external"
import style2 from "../../static/loginPage/login.css?vue&type=style&index=2&id=b7432342&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7432342",
  null
  
)

export default component.exports